module.exports = __webpack_public_path__ + "img/porre_kylling.c7e9ff0e.jpg";